import {
  PROJECTMAIL_GET_TICKETSSUCCESS,
  PROJECTMAIL_GET_TICKETS_ON_EDIT_SUCCESS,
  PROJECTMAIL_SET_FILTER,
  PROJECTMAIL_RESET_FILTER,
  PROJECTMAIL_GET_TAGSSUCCESS,
  PROJECTMAIL_SET_COLORMAP,
  PROJECTMAIL_CHANGE_CURRENT_TYPE,
  PROJECTMAIL_GET_TICKET_SUM_SSUCCESS,
  PROJECTMAIL_GET_TICKETS_SUM_FAILURE,
  PROJECTMAIL_SET_LASTWORKEDTICKET,
  PROJECTMAIL_PUSH_TICKET_TO_HISTORY,
  PROJECTMAIL_SET_TABLELAYOUT,
  PROJECTMAIL_GET_EMAIL_SUCCESS,
  PROJECTMAIL_SET_CURRENTROW,
  PROJECTMAIL_ACTIVATE_BELL_FOR_TICKTTYPE,
  PROJECTMAIL_DEACTIVATE_BELL_FOR_TICKTTYPE,
  PROJECTMAIL_WS_CALL_TICKETUPDATE,
  PROJECTMAIL_WS_CALL_NEW_TICKET,
  PROJECTMAIL_SET_ROW_AMOUNT,
  PROJECTMAIL_WEBSOCKETERROR_RELOAD,
  PROJECTMAIL_TOGGLE_TAGMODAL,
  PROJECTMAIL_TOGGLE_INFOMODAL,
  PROJECTMAIL_TOGGLE_EMAILMODAL,
} from "../../actions/projectmail";

import { GROUP_ID_EVENT, GROUP_ID_WEBCAST } from "../../config";

/** Baseline ticket counts when the summary API is unavailable (e.g. 404) or returns partial data */
export function createEmptySumOfTickets() {
  return {
    webcast: 0,
    event: 0,
    urgent: 0,
    own: 0,
  };
}

export const initialSearchFilter = {
  changed: false,
  id: "",
  title: "",
  tags: "",
  owner: "",
  operator: "",
  additionalOperator: "",
  orderProduct: "",
  orderCustomerNo: "",
  orderStatus: "",
  eventStartTime: null,
  eventEndTime: null,
  size: 25,
  webcastID: "",
  customer: "",
  orderID: "",
  externalID: "",
};

export const defaultTableLayout = ["title", "customer", "sortTimeStamp", "owner", "webcastID", "orderID"];

/** Must match {@link EnhancedTable} rowsPerPageOptions */
const EMAIL_TABLE_ROW_AMOUNTS = [10, 25, 50, 100];

function sanitizeEmailTableRowAmount(raw) {
  const n = Number(raw);
  return EMAIL_TABLE_ROW_AMOUNTS.includes(n) ? n : 10;
}

const loadtableLayout = () => {
  if (localStorage.getItem("projectMail__tableLayout_version_13052022") !== null) {
    const object = JSON.parse(localStorage.getItem("projectMail__tableLayout_version_28062022"));
    return object;
  }
  return {};
};

const loadBellsForTicketType = () => {
  if (localStorage.getItem("projectMail_bells") !== null) {
    const array = JSON.parse(localStorage.getItem("projectMail_bells"));
    return array;
  }
  return [];
};

const loadRowAmount = () => {
  if (localStorage.getItem("projectMail_rowAmount") !== null) {
    try {
      return sanitizeEmailTableRowAmount(JSON.parse(localStorage.getItem("projectMail_rowAmount")));
    } catch {
      return 10;
    }
  }
  return 10;
};

const sortTimeStamp = ticket => {
  // additional logic
  // return when own teammember writes on an email
  // reason behind this is: all teammember are agents with this there will be no changes in timestamp when own members are answering
  // if (ticket.owner !== ticket.updatedBy && ticket.lastContactCustomerAt && ticket.lastContactAgentAt) {
  //   if (ticket.lastContactCustomerAt < ticket.lastContactAgentAt && ticket.lastContactAgentAt !== 0) {
  //     return ticket.lastContactAgentAt;
  //   }
  // }
  // // default logic
  // if (ticket.lastContactCustomerAt && ticket.lastContactCustomerAt !== 0) return ticket.lastContactCustomerAt;
  // if (ticket.lastContactAgentAt && ticket.lastContactAgentAt !== 0) return ticket.lastContactAgentAt;
  // if (ticket.lastContactAt && ticket.lastContactAt !== 0) return ticket.lastContactAt;
  // if (ticket.lastUpdatedAt && ticket.lastUpdatedAt !== 0) return ticket.lastUpdatedAt;
  // if (ticket.createdAt && ticket.createdAt !== 0) return ticket.createdAt;
  // return 0;
  return ticket.lastUpdatedAt;
};

export const initialState = {
  tags: [],
  tickets: { ticketHistory: [] },
  infoTicket: {},
  ticketsOnEdit: {},
  searchFilter: {},
  colorMap: {},
  currentType: undefined,
  sumOfTickets: createEmptySumOfTickets(),
  lastWorkedTicket: -1,
  tableLayout: loadtableLayout(),
  currentRow: undefined,
  activeBellsForTicketType: loadBellsForTicketType(),
  rowAmount: loadRowAmount(),
  webSocketError: false,
  articles: {},
  infoModalOpen: false,
  tagModalOpen: false,
  emailModalOpen: false,
};
const projectmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECTMAIL_TOGGLE_EMAILMODAL: {
      return {
        ...state,
        emailModalOpen: action.open,
      };
    }
    case PROJECTMAIL_TOGGLE_INFOMODAL: {
      return {
        ...state,
        infoModalOpen: action.open,
      };
    }
    case PROJECTMAIL_TOGGLE_TAGMODAL: {
      return {
        ...state,
        tagModalOpen: action.open,
      };
    }
    case PROJECTMAIL_GET_TICKETS_ON_EDIT_SUCCESS: {
      return {
        ...state,
        ticketsOnEdit: action.payload,
      };
    }
    case PROJECTMAIL_GET_TICKETSSUCCESS: {
      const newTickets = action.payload[Object.keys(action.payload)[0]].map(ticket => {
        ticket.sortTimeStamp = sortTimeStamp(ticket);
        return ticket;
      });
      let ticketObject;
      if (state.tickets[Object.keys(action.payload)[0]] === undefined) {
        ticketObject = { [Object.keys(action.payload)[0]]: newTickets };
      } else {
        ticketObject = { [Object.keys(action.payload)[0]]: newTickets };
      }
      return {
        ...state,
        tickets: {
          ...state.tickets,
          ...ticketObject,
        },
      };
    }
    case PROJECTMAIL_SET_FILTER: {
      return {
        ...state,
        searchFilter: { ...state.searchFilter, [action.ticketType]: { ...action.filter, changed: true } },
      };
    }
    case PROJECTMAIL_RESET_FILTER: {
      return {
        ...state,
        searchFilter: { ...state.searchFilter, [action.ticketType]: initialSearchFilter },
      };
    }
    case PROJECTMAIL_GET_TAGSSUCCESS: {
      return {
        ...state,
        tags: action.payload,
      };
    }
    case PROJECTMAIL_SET_COLORMAP: {
      return {
        ...state,
        colorMap: action.colorMap,
      };
    }
    case PROJECTMAIL_CHANGE_CURRENT_TYPE: {
      return {
        ...state,
        currentType: action.currentType,
      };
    }
    case PROJECTMAIL_GET_TICKET_SUM_SSUCCESS: {
      return {
        ...state,
        sumOfTickets: { ...createEmptySumOfTickets(), ...(action.payload && typeof action.payload === "object" ? action.payload : {}) },
      };
    }
    case PROJECTMAIL_GET_TICKETS_SUM_FAILURE: {
      return {
        ...state,
        sumOfTickets: createEmptySumOfTickets(),
      };
    }
    case PROJECTMAIL_SET_LASTWORKEDTICKET: {
      return {
        ...state,
        lastWorkedTicket: action.lastWorkedTicket,
      };
    }
    case PROJECTMAIL_PUSH_TICKET_TO_HISTORY: {
      const newTicketHistory = [...state.tickets.ticketHistory].filter(ticket => ticket.id !== action.ticket.id);
      newTicketHistory.push(action.ticket);
      return {
        ...state,
        tickets: { ticketHistory: newTicketHistory, ...state.tickets },
      };
    }
    case PROJECTMAIL_SET_TABLELAYOUT: {
      localStorage.setItem(
        "projectMail__tableLayout",
        JSON.stringify({ ...state.tableLayout, [action.ticketType]: action.tableLayout })
      );
      return {
        ...state,
        tableLayout: { ...state.tableLayout, [action.ticketType]: action.tableLayout },
      };
    }
    case PROJECTMAIL_GET_EMAIL_SUCCESS: {
      return {
        ...state,
        articles: { ...state.articles, [state.currentRow.id]: action.payload },
      };
    }
    case PROJECTMAIL_SET_CURRENTROW: {
      return {
        ...state,
        currentRow: action.row,
      };
    }
    case PROJECTMAIL_ACTIVATE_BELL_FOR_TICKTTYPE: {
      const currentBells = state.activeBellsForTicketType;
      if (currentBells.indexOf(action.ticketType) === -1) {
        currentBells.push(action.ticketType);
      }
      localStorage.setItem("projectMail_bells", JSON.stringify(currentBells));
      return {
        ...state,
        activeBellsForTicketType: currentBells,
      };
    }
    case PROJECTMAIL_SET_ROW_AMOUNT: {
      const rowAmount = sanitizeEmailTableRowAmount(action.rowAmount);
      localStorage.setItem("projectMail_rowAmount", JSON.stringify(rowAmount));
      return {
        ...state,
        rowAmount,
      };
    }
    case PROJECTMAIL_DEACTIVATE_BELL_FOR_TICKTTYPE: {
      const currentBells = state.activeBellsForTicketType;
      const index = currentBells.indexOf(action.ticketType);
      if (index > -1) {
        currentBells.splice(index, 1);
      }
      localStorage.setItem("projectMail_bells", JSON.stringify(currentBells));
      return {
        ...state,
        activeBellsForTicketType: currentBells,
      };
    }
    case PROJECTMAIL_WS_CALL_NEW_TICKET: {
      const stateSumOfTickets = state.sumOfTickets;
      const updatedTicket = action.ticketObject.Ticket;
      updatedTicket.sortTimeStamp = sortTimeStamp(updatedTicket);
      const stateTickets = state.tickets;
      if (updatedTicket.group === GROUP_ID_WEBCAST) {
        stateSumOfTickets.webcast += 1;
        if (stateTickets.webcast !== undefined) {
          stateTickets.webcast.push(updatedTicket);
        }
      }
      if (updatedTicket.group === GROUP_ID_EVENT) {
        stateSumOfTickets.event += 1;
        if (stateTickets.event !== undefined) {
          stateTickets.event.push(updatedTicket);
        }
      }
      if (updatedTicket.owner === action.username) {
        stateTickets.own.push(updatedTicket);
      }
      return {
        ...state,
        tickets: { ...stateTickets },
        sumOfTickets: { ...stateSumOfTickets },
      };
    }
    case PROJECTMAIL_WS_CALL_TICKETUPDATE: {
      const stateSumOfTickets = state.sumOfTickets;
      const stateTickets = state.tickets;
      const updatedTicket = action.ticketObject.Ticket;
      updatedTicket.sortTimeStamp = sortTimeStamp(updatedTicket);
      const updateableTickets = Object.entries(stateTickets).map(([key, values]) => {
        return { index: values.findIndex(ticket => updatedTicket.id === ticket.id), type: key };
      });
      if (updatedTicket.state === "closed" || updatedTicket.state === "merged") {
        updateableTickets
          .filter(elm => elm.index !== -1)
          .forEach(elm => {
            if (elm.type !== "ticketHistory" && elm.type !== "closed") {
              stateTickets[elm.type].splice(elm.index, 1);
              stateSumOfTickets[elm.type] += -1;
            }
          });
      } else {
        updateableTickets
          .filter(elm => elm.index !== -1)
          .forEach(elm => {
            stateTickets[elm.type][elm.index] = updatedTicket;
            if (elm.type === "event" && updatedTicket.group !== GROUP_ID_EVENT) {
              stateTickets[elm.type].splice(elm.index, 1);
            }
            if (elm.type === "webcast" && updatedTicket.group !== GROUP_ID_WEBCAST) {
              stateTickets[elm.type].splice(elm.index, 1);
            }
          });
        if (
          updatedTicket.group === GROUP_ID_EVENT &&
          updateableTickets.some(elm => elm.type === "event" && elm.index === -1)
        ) {
          stateTickets.event.push(updatedTicket);
          stateSumOfTickets.event += 1;
        }
        if (
          updatedTicket.group === GROUP_ID_WEBCAST &&
          updateableTickets.some(elm => elm.type === "webcast" && elm.index === -1)
        ) {
          stateTickets.webcast.push(updatedTicket);
          stateSumOfTickets.webcast += 1;
        }
        if (
          action.username === updatedTicket.owner &&
          updateableTickets.some(elm => elm.type === "own" && elm.index === -1)
        ) {
          stateTickets.own.push(updatedTicket);
          stateSumOfTickets.own += 1;
        }
        if (
          action.username !== updatedTicket.owner &&
          updateableTickets.some(elm => elm.type === "own" && elm.index !== -1)
        ) {
          const { index } = updateableTickets.filter(elm => elm.type === "own")[0];
          stateTickets.own.splice(index, 1);
          stateSumOfTickets.own -= 1;
        }
        if (
          updatedTicket.tags.indexOf("#urgent") > 0 &&
          updateableTickets.some(elm => elm.type === "urgent" && elm.index === -1)
        ) {
          stateTickets.urgent.push(updatedTicket);
          stateSumOfTickets.urgent += 1;
        }
      }
      const { articles } = state;
      if (articles[updatedTicket.id] !== undefined) {
        delete articles[updatedTicket.id];
      }
      return {
        ...state,
        articles,
        tickets: { ...stateTickets },
        sumOfTickets: { ...stateSumOfTickets },
      };
    }
    case PROJECTMAIL_WEBSOCKETERROR_RELOAD:
      // eslint-disable-next-line no-new
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("rights");
      setTimeout(() => window.location.reload(), 10000);
      return { ...state, webSocketError: true };
    default:
      return state;
  }
};

export default projectmailReducer;
